"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogStore = void 0;
var React = _interopRequireWildcard(require("react"));
var _store = require("@base-ui-components/utils/store");
var _empty = require("@base-ui-components/utils/empty");
var _getEmptyRootContext = require("../../floating-ui-react/utils/getEmptyRootContext");
const selectors = {
  open: (0, _store.createSelector)(state => state.open),
  modal: (0, _store.createSelector)(state => state.modal),
  nested: (0, _store.createSelector)(state => state.nested),
  nestedOpenDialogCount: (0, _store.createSelector)(state => state.nestedOpenDialogCount),
  disablePointerDismissal: (0, _store.createSelector)(state => state.disablePointerDismissal),
  openMethod: (0, _store.createSelector)(state => state.openMethod),
  descriptionElementId: (0, _store.createSelector)(state => state.descriptionElementId),
  titleElementId: (0, _store.createSelector)(state => state.titleElementId),
  mounted: (0, _store.createSelector)(state => state.mounted),
  transitionStatus: (0, _store.createSelector)(state => state.transitionStatus),
  popupProps: (0, _store.createSelector)(state => state.popupProps),
  floatingRootContext: (0, _store.createSelector)(state => state.floatingRootContext),
  activeTriggerId: (0, _store.createSelector)(state => state.activeTriggerId),
  activeTriggerElement: (0, _store.createSelector)(state => state.mounted && state.activeTriggerId != null ? state.triggers.get(state.activeTriggerId) ?? null : null),
  triggers: (0, _store.createSelector)(state => state.triggers),
  popupElement: (0, _store.createSelector)(state => state.popupElement),
  viewportElement: (0, _store.createSelector)(state => state.viewportElement),
  payload: (0, _store.createSelector)(state => state.payload),
  activeTriggerProps: (0, _store.createSelector)(state => state.activeTriggerProps),
  inactiveTriggerProps: (0, _store.createSelector)(state => state.inactiveTriggerProps),
  role: (0, _store.createSelector)(state => state.role)
};
class DialogStore extends _store.ReactStore {
  constructor(initialState) {
    super(createInitialState(initialState), {
      popupRef: /*#__PURE__*/React.createRef(),
      backdropRef: /*#__PURE__*/React.createRef(),
      internalBackdropRef: /*#__PURE__*/React.createRef(),
      preventUnmountingOnCloseRef: {
        current: false
      }
    }, selectors);
  }
  setOpen = (nextOpen, eventDetails) => {
    eventDetails.preventUnmountOnClose = () => {
      this.context.preventUnmountingOnCloseRef.current = true;
    };
    if (!nextOpen && eventDetails.trigger == null && this.state.activeTriggerId != null) {
      // When closing the dialog, pass the old trigger to the onOpenChange event
      // so it's not reset too early (potentially causing focus issues in controlled scenarios).
      eventDetails.trigger = this.state.triggers.get(this.state.activeTriggerId);
    }
    this.context.onOpenChange?.(nextOpen, eventDetails);
    if (eventDetails.isCanceled) {
      return;
    }
    const details = {
      open: nextOpen,
      nativeEvent: eventDetails.event,
      reason: eventDetails.reason,
      nested: this.state.nested
    };
    this.state.floatingRootContext.events?.emit('openchange', details);
    this.set('open', nextOpen);
    const newTriggerId = eventDetails.trigger?.id ?? null;
    if (newTriggerId || nextOpen) {
      this.set('activeTriggerId', newTriggerId);
    }
  };
}
exports.DialogStore = DialogStore;
function createInitialState(initialState = {}) {
  return {
    disablePointerDismissal: false,
    modal: true,
    open: false,
    nested: false,
    popupElement: null,
    viewportElement: null,
    activeTriggerId: null,
    descriptionElementId: undefined,
    titleElementId: undefined,
    openMethod: null,
    mounted: false,
    transitionStatus: 'idle',
    nestedOpenDialogCount: 0,
    triggers: new Map(),
    floatingRootContext: (0, _getEmptyRootContext.getEmptyRootContext)(),
    payload: undefined,
    activeTriggerProps: _empty.EMPTY_OBJECT,
    inactiveTriggerProps: _empty.EMPTY_OBJECT,
    popupProps: _empty.EMPTY_OBJECT,
    role: 'dialog',
    ...initialState
  };
}